const state = {
  info: sessionStorage.getItem('station') || '{}',
  control: sessionStorage.getItem('control'),
  gtypes: sessionStorage.getItem('gtypes') || '{}',
}
const mutations = {
  SET_INFO: (state, data) => {
    sessionStorage.setItem('station', JSON.stringify(data))
    state.info = JSON.stringify(data)
  },
  SET_CONTROL: (state, data) => {
    sessionStorage.setItem('control', data)
    state.control = data
  },
  SET_GTYPES: (state, data) => {
    sessionStorage.setItem('gtypes', JSON.stringify(data))
    state.gtypes = JSON.stringify(data)
  }
}
const actions = {
  setStationInfo ({ commit }, data) {
    commit('SET_INFO', data)
  },
  setStationControl ({ commit }, data) {
    commit('SET_CONTROL', data)
  },
  setStationGtypes ({ commit }, data) {
    commit('SET_GTYPES', data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
